import { useEffect, useRef, useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import PricingCard from '@/v2/pages/Plans/components/pricing-card';
import './MyAccountPricingCarousel.css';

function MyAccountPricingCarousel({
	plans,
	isYearly,
	onOpenCheckout,
	currentSubscriptionDetails,
	currentSubscriptionLoading
}) {
	const defaultSlideIndex = plans.length > 1 ? 1 : 0;
	const [activeSlide, setActiveSlide] = useState(defaultSlideIndex);
	const swiperRef = useRef(null);

	useEffect(() => {
		setActiveSlide(defaultSlideIndex);
		const swiperInstance = swiperRef.current?.swiper;
		if (swiperInstance) {
			swiperInstance.slideTo(defaultSlideIndex, 0);
		}
	}, [defaultSlideIndex, plans]);

	const slideTo = index => {
		const swiperInstance = swiperRef.current?.swiper;
		if (swiperInstance) {
			swiperInstance.slideTo(index);
		}
	};

	const handlePrevious = () => slideTo(Math.max(activeSlide - 1, 0));
	const handleNext = () => slideTo(Math.min(activeSlide + 1, plans.length - 1));

	return (
		<div className="ma-carousel">
			<div className="ma-carousel__viewport">
				<button
					type="button"
					className="ma-carousel__nav ma-carousel__nav--prev"
					onClick={handlePrevious}
					disabled={activeSlide === 0}
					aria-label="Show previous plan"
				>
					<ChevronLeftIcon fontSize="small" />
				</button>

				<Swiper
					ref={swiperRef}
					spaceBetween={16}
					initialSlide={defaultSlideIndex}
					slidesPerView="auto"
					centeredSlides
					onSlideChange={swiper => setActiveSlide(swiper.activeIndex)}
				>
					{plans.map((plan, index) => (
						<SwiperSlide
							key={plan.id}
							className={index === activeSlide ? 'active' : 'blurred'}
							onClick={() => slideTo(index)}
						>
							<PricingCard
								plan={plan}
								isYearly={isYearly}
								isBestValue={index === 1}
								isMobile
								onOpenCheckout={onOpenCheckout}
								currentSubscriptionDetails={currentSubscriptionDetails}
								currentSubscriptionLoading={currentSubscriptionLoading}
							/>
						</SwiperSlide>
					))}
				</Swiper>

				<button
					type="button"
					className="ma-carousel__nav ma-carousel__nav--next"
					onClick={handleNext}
					disabled={activeSlide === plans.length - 1}
					aria-label="Show next plan"
				>
					<ChevronRightIcon fontSize="small" />
				</button>
			</div>

			<div className="ma-carousel__pagination" aria-label="Choose a plan">
				{plans.map((plan, index) => (
					<button
						key={`${plan.id}-dot`}
						type="button"
						className={`ma-carousel__dot${index === activeSlide ? ' is-active' : ''}`}
						onClick={() => slideTo(index)}
						aria-label={`Show ${plan.name || plan.id} plan`}
						aria-pressed={index === activeSlide}
					/>
				))}
			</div>
		</div>
	);
}

export default MyAccountPricingCarousel;
